import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TrainingState } from "./types";
import { sendPersonalTrainingOrder, sendSchoolTrainingOrder } from "./asyncActions";

const initialState: TrainingState = {
  isLoading: false,
  successModal: false, 
  error: null,
};

const trainingSlice = createSlice({
  name: "training",
  initialState,
  reducers: {
    closeSuccessModal(state) {
      state.successModal = false;
    },
    clearState(state) {
      state.isLoading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendSchoolTrainingOrder.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(sendSchoolTrainingOrder.fulfilled, (state) => {
        state.isLoading = false;
        state.successModal = true;
      })
      .addCase(sendSchoolTrainingOrder.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(sendPersonalTrainingOrder.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(sendPersonalTrainingOrder.fulfilled, (state) => {
        state.isLoading = false;
        state.successModal = true;
      })
      .addCase(sendPersonalTrainingOrder.rejected, (state) => {
        state.isLoading = false;
      })
  },
});

export const { closeSuccessModal, clearState } = trainingSlice.actions;

export default trainingSlice.reducer;
